// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"144c841b","879":"c31963a4"}[chunkId] + ".chunk.js";
};